export class TipologieProdottiItem {
	constructor() {
		this.itemID = null;
		this.tipologiaProdotto = null;
		this.descrizioneTipologia = null;
	}
	itemID: number | null;
	tipologiaProdotto: string;
	descrizioneTipologia: string;
}